import { combineReducers } from 'redux'

import replyType from './replyType'

const enums = combineReducers({
  replyType,
})

export default enums
